console.log("trellis-video.js");

// Grab all video-controls--sound containers
const videoControlSoundElements = document.querySelectorAll(
	".video-controls--sound"
);
muteControls(videoControlSoundElements);

// Mute/Un-mute icon controls
function muteControls(videoControlSoundElements) {
	// Add click event to mute and unmute icons
	videoControlSoundElements.forEach((videoControlSoundElement) => {
		videoControlSoundElement.addEventListener("click", (event) => {
			const target = event.target;

			// Grab the clicked icons container
			const videoIconContainer = target.closest(".video-controls--sound");
			// Toggle class to decide which icon to show and which video function to run
			videoIconContainer.classList.toggle("sound--on");

			// Run the corresponding funtion depending if the video needs sound or not.
			if (youtubePlayer) {
				videoIconContainer.classList.contains("sound--on")
					? youtubePlayer.unMute()
					: youtubePlayer.mute();
			}

			const vimeoVideoContainer = target
				.closest(".trellis-video")
				.querySelector(".js-vimeo");
			if (vimeoVideoContainer) {
				const player = new Vimeo.Player(vimeoVideoContainer);
				videoIconContainer.classList.contains("sound--on")
					? player.setVolume(0.5)
					: player.setVolume(0.0);
			}

			const shopifyVideoContainer = target
				.closest(".trellis-video")
				.querySelector(".js-shopify-video");
			if (shopifyVideoContainer) {
				videoIconContainer.classList.contains("sound--on")
					? (shopifyVideoContainer.muted = false)
					: (shopifyVideoContainer.muted = true);
			}
		});
	});
}
